import { render, staticRenderFns } from "./formulator-additive-selection.vue?vue&type=template&id=63303c23&"
import script from "./formulator-additive-selection.vue?vue&type=script&lang=js&"
export * from "./formulator-additive-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports